module.exports = __webpack_public_path__ + "static/media/beru.302904fd.png";